module.exports = __webpack_public_path__ + "media/images/instructions/aws-iam-roles-2-create-policy-9a1e59cf477bb2bb801d72fce36ac2e8.png";